module.exports = __webpack_public_path__ + "img/menu-icon.401d3841.svg";